<template>
	<!--TODO: Подумать, как сделать так, чтобы сценарии с LoyaltyScenario не дублировали код-->
	<div class="col-12">
		<div v-if="isUserCorporateClient && hasLoyaltyAccount && isPageRestrictedForUser">
			<div class="container theme-inverse text-center justify-content-center p-5">
				<div class="title">
					Вы уже зарегистрированы в программе лояльности
				</div>
				<button class="btn btn-primary mt-4" @click="$router.push('/user/profile/loyalty-b2b/card/')">
					Перейти в личный кабинет
				</button>
			</div>
		</div>
		<div v-else>
			<div class="panel_header">
				<div class="row align-items-end">
					<div v-if="block.block_title" class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
					<div v-if="block.subtitle" class="col-12">
						<p>{{ block.subtitle }}</p>
					</div>
				</div>
			</div>
			<div
				v-if="mounted && autocompleted"
				class="row"
			>
				<div class="col-12 col-lg data-block">
					<FormulateForm
						v-if="((isAuthorized && block.authentication_required)
							|| !block.authentication_required)"
						v-model="formValues"
						:schema="schema"
						class="row"
						@submit="submit"
						@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
						@setCompanyInfo="setCompanyInfo"
						@validatePhone="validatePhone"
					>
						<div class="col-12 order-0 mb-4">
							<products-component v-model="products" :block="block" />
						</div>

						<div class="col-12 order-10 mb-4">
							<div v-html="block.footer_text" />

							<div v-if="block.show_amount">
								<p class="title">
									Стоимость: {{ amount }} руб
								</p>
							</div>

							<agreement-input />

							<PublicOfferAgreementInput
								v-for="(item, index) in block.agreements"
								:key="index"
								:href="item"
							/>

							<advertising-mailings-input />

							<loyalty-registration-input :required="false" />

							<b2b-alumni-input v-if="block.showb2bAlumniInput" />

							<!-- TODO: сделать добавление галочек из админки -->
							<FormulateInput
								v-if="! (isUserCorporateClient && hasLoyaltyAccount)"
								class="col-12 px-0 small"
								:class="additionalClasses"
								type="checkbox"
								name="registerLoyalty"
								:validation="isRequiredRegistration ? 'required' : ''"
								:validation-messages="{
									required: `${$t('agreementRequired')}`
								}"
								data-action="panels-agreementinput-loyalty-program-b2b-registration-agreement"
							>
								<template #label="{ id }">
									<label :for="id" class="ml-2">
										Отправляя форму, я соглашаюсь стать участником Программы лояльности Школы для корпоративных клиентов и принимаю
										<a href="/storage/loyality-b2b_legal.pdf" class="font-weight-bold" target="_blank">
											правила участия
										</a>
									</label>
								</template>
							</FormulateInput>
						</div>

						<div class="col-12 order-10">
							<FormulateInput
								type="submit"
								class="mb-0 mt-2"
								:disabled="isLoadingSubmit"
							>
								<b-spinner
									v-if="isLoadingSubmit"
									style="
										margin-right: 15px;
										width: 1.3em;
										height: 1.3em;
									"
								/>
								{{ isLoadingSubmit ? $t("sending") : $t("send") }}
							</FormulateInput>
							<div v-if="errorMessage" class="text-success mt-2">
								{{ errorMessage }}
							</div>
							<CookieError v-if="isErrorCookie" />
						</div>

						<div v-if="!isAuthorized && block.authentication_required">
							<div class="col-12 mb-3">
								{{ $t("necessaryRegister") }}
							</div>
							<FormulateInput
								type="button"
								class="mb-0 col-12"
								:disabled="isLoadingSubmit"
								@click="showLoginPopup"
							>
								{{ $t("logIn") }}
							</FormulateInput>
						</div>
					</FormulateForm>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import formScenarioActions from '@/constants/formScenarioActions';

export default {
	components: {
		AgreementInput,
		ProductsComponent,
		AdvertisingMailingsInput,
		CookieError,
	},
	mixins: [formulateFormScenario],
	props: {
		additionalClasses: { type: String, default: '' },
	},
	computed: {
		hasLoyaltyAccount() {
			return !!this.$auth?.user?.loyalty_id;
		},
		isUserCorporateClient() {
			return !!this.$auth?.user?.is_corporate_client;
		},
		isPageRestrictedForUser() {
			return this.block.is_user_quantity_restriction_enabled
				&& parseInt(this.block.user_restriction_quantity_per_user) === 1;
		},
		isRequiredRegistration() {
			return this.block.form_scenario_action !== formScenarioActions.CONSULTATION;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}
.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;
	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}
		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}
</style>
